<script>
import draggable from "vuedraggable";
import MultiSelect from "vue-multiselect";
import { staff_hk_status } from "@/helpers/global.variable";
import { required } from "vuelidate/lib/validators";

// Custom Components
import PageHeader from "@/components/page-header";
import hkService from "@/helpers/APIService/hk.service";
import Middleware from "@/helpers/middlewares";
import errorHandler from "@/helpers/errorHandler";
import { authComputed } from "@/state/helpers";
import appConfig from "@/app.config";

// Get Task Sheet Details Component

export default {
  page: {
    title: "Task Sheet Details",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    PageHeader,
    draggable,
    MultiSelect,
  },
  computed: {
    ...authComputed,
    dragOptions() {
      return {
        animation: 0,
        group: "description",
        disabled: !this.editable,
        ghostClass: "ghost",
      };
    },
  },
  data() {
    return {
      title: "Task sheet Details",
      editable: true,
      isDragging: false,
      delayedDragging: false,
      isDataLoading: false,
      taskStaffData: {},
      sheetId: "",
      changeStatus: "",
      HKStatusOptions: staff_hk_status,
      rightClick: false,
      taskId: "",
      staffOptions: [],
      selectStaffToMove: "",
      TTOptions: [
        { value: "full", text: "Full", disabled: false },
        { value: "green", text: "Half", disabled: false },
      ],
      reasonTitle: "",
      reasonStatus: "",
      reason: "",
      reasonOptions: [],
      submitted: false,
      relatedElement: {},
      draggedElement: {},
      repeated: false,
    };
  },
  mounted() {
    this.getTaskSheetDetails();
  },
  watch: {
    isDragging(newValue) {
      if (newValue) {
        this.delayedDragging = true;
        return;
      }
      this.$nextTick(() => {
        this.delayedDragging = false;
      });
    },
  },
  validations: {
    reason: { required },
  },
  methods: {
    // Method is use for set task status options
    getTaskStatusOptions(task) {
      let statusOptions = [];
      if (task.task_status == "hk_pending") {
        statusOptions.push(
          { name: "In Process", type: "hk_in_progress" },
          { name: "Discrepancy", type: "hk_discrepancy" },
          { name: "DND", type: "hk_dnd" }
        );
      } else if (task.task_status == "hk_in_progress") {
        statusOptions.push(
          { name: "Paused", type: "mark_delay_service" },
          { name: "Completed", type: "hk_completed" }
        );
      } else if (
        task.task_status == "hk_discrepancy" ||
        task.task_status == "hk_dnd"
      ) {
        statusOptions.push(
          { name: "Discrepancy", type: "hk_discrepancy" },
          { name: "DND", type: "hk_dnd" },
          { name: "In Progress", type: "hk_in_progress" },
          { name: "Paused", type: "mark_delay_service" }
        );
      } else if (task.task_status == "mark_delay_service") {
        statusOptions.push(
          { name: "In Progress", type: "hk_in_progress" },
          { name: "Completed", type: "hk_completed" }
        );
      } else if (task.task_status == "hk_completed") {
        statusOptions.push(
          { name: "Insp Rejected", type: "in_reject" },
          { name: "Insp Pending", type: "in_pending" }
        );
      } else if (task.task_status == "in_pending") {
        statusOptions.push({ name: "Insp Done", type: "in_done" });
      }
      return statusOptions;
    },
    getTaskSheetDetails() {
      if (this.repeated !== true) {
        this.taskStaffData = [];
        this.isDataLoading = true;
      }
      hkService
        .getTaskSheet(this.$route.params.id)
        .then((response) => {
          this.isDataLoading = false;
          let data = response.stafftasksheet_set.map((staff) => {
            let floor = [];
            let tasks = staff.hkstafftask_set.map((task) => {
              if (
                task.task_status == "hk_completed" ||
                task.task_status == "hk_in_progress" ||
                task.task_status == "in_reject"
              ) {
                task = { ...task, fixed: true };
              } else {
                task = { ...task, fixed: false };
              }
              if (
                floor.length != 0 &&
                !floor.includes(task.room.section.name)
              ) {
                floor.push(task.room.section.name);
              }
              const statusOptions = this.getTaskStatusOptions(task);
              task = { ...task, statusOptions };
              return task;
            });
            staff = { ...staff, floor, hkstafftask_set: tasks };
            return staff;
          });
          data.sort((a, b) =>
            a.staff_user.first_name.localeCompare(b.staff_user.first_name)
          );

          response.stafftasksheet_set = data;
          this.taskStaffData = response;
          this.title = `#${response.sheet_id} ${response.sheet_date} Guest Room Cleaning Task Sheet`;
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // Method is use for show drop down
    showDropDown(id, status) {
      this.sheetId = id;
      this.changeStatus = status;
      this.rightClick = false;
      this.taskId = "";
    },
    // Method is use for update task
    onMove({ relatedContext, draggedContext }) {
      this.relatedElement = relatedContext;
      this.draggedElement = draggedContext;
      return (
        (!relatedContext.element || !relatedContext.element.fixed) &&
        !draggedContext.element.fixed
      );
    },
    // Method is use for call update status API
    updateTaskStatus(id, data) {
      hkService
        .updateTaskSheet(id, data)
        .then((response) => {
          Middleware.notification("Status successfully changed !!", "success");
          this.taskStaffData.stafftasksheet_set =
            this.taskStaffData.stafftasksheet_set.map((item) => {
              item.pending_tasks = 0;
              item.in_progress_tasks = 0;
              item.completed_tasks = 0;
              item.hkstafftask_set = item.hkstafftask_set.map((task) => {
                if (task.id === response.id) {
                  if (this.changeStatus === "TTStatus") {
                    task.task_type = response.task_type;
                  }
                  if (this.changeStatus === "TaskStatus") {
                    task.task_status = response.task_status;
                  }
                  const statusOptions = this.getTaskStatusOptions(response);
                  task.statusOptions = statusOptions;
                }
                if (task.task_status === "hk_pending") {
                  item.pending_tasks = item.pending_tasks + 1;
                } else if (task.task_status === "hk_in_progress") {
                  item.in_progress_tasks = item.in_progress_tasks + 1;
                } else if (task.task_status === "hk_completed") {
                  item.completed_tasks = item.completed_tasks + 1;
                }
                return task;
              });
              return item;
            });
          this.sheetId = "";
          this.changeStatus = "";
          this.taskId = "";
        })
        .catch((error) => {
          errorHandler(error);
          this.sheetId = "";
          this.changeStatus = "";
          this.taskId = "";
        });
    },
    // Method is use for change status
    changeStatusFunc(data) {
      if (data.status !== undefined || data.task_status.type !== undefined) {
        if (data.task_status.type === "hk_dnd") {
          this.reasonOptions = [];
          this.reason = "";
          this.taskId = data.id;
          this.reasonTitle = "Select DND Reason";
          this.reasonStatus = "DND";
          hkService
            .getDNDReasonList()
            .then((response) => {
              response.map((item) => {
                if (item.is_active) {
                  this.reasonOptions.push({
                    value: item.id,
                    text: item.name,
                    disabled: false,
                  });
                }
              });
            })
            .catch((error) => {
              errorHandler(error);
            });

          this.$refs["reason-modal"].show();
        } else if (data.task_status.type === "hk_discrepancy") {
          this.reasonOptions = [];
          this.reason = "";
          this.taskId = data.id;
          this.reasonTitle = "Select Discrepancy Reason";
          this.reasonStatus = "Discrepancy";
          hkService
            .getDiscrepancyReasonList()
            .then((response) => {
              response.map((item) => {
                this.reasonOptions.push({
                  value: item.id,
                  text: item.name,
                  disabled: false,
                });
              });
            })
            .catch((error) => {
              errorHandler(error);
            });

          this.$refs["reason-modal"].show();
        } else {
          let passData = {};
          if (this.changeStatus === "TTStatus") {
            passData = {
              task_type: data.status.value,
            };
          }
          if (this.changeStatus === "TaskStatus") {
            passData = {
              task_status: data.task_status.type,
            };
          }
          this.updateTaskStatus(data.id, passData);
        }
      }
    },
    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.handleSubmit();
    },
    // Method is use for update DND and Discrepancy reason
    handleSubmit() {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        this.submitted = false;
        let status = "";
        if (this.reasonStatus == "DND") {
          status = "hk_dnd";
        }
        if (this.reasonStatus == "Discrepancy") {
          status = "hk_discrepancy";
        }
        let data = {
          task_status: status,
          task_status_change_reason: this.reason.name,
        };
        this.updateTaskStatus(this.taskId, data);
        this.resetModal();
      }
    },
    resetModal() {
      this.$refs["reason-modal"].hide();
    },
    // Method is use for generate a avatar
    avatarGenerator(name) {
      return Middleware.avatarGenerator(name);
    },
    // Method is use for find other staff where we can move a task
    func(data) {
      this.sheetId = "";
      this.changeStatus = "";
      this.rightClick = true;
      this.taskId = data.id;
      this.staffOptions = [];
      this.taskStaffData.stafftasksheet_set.map((item) => {
        if (item.id !== data.staff_task_sheet) {
          this.staffOptions.push({
            value: item.id,
            text: item.staff_user.first_name + " " + item.staff_user.last_name,
          });
        }
      });
    },
    // Method is use to manage response with original data
    getResponse(data, response, status) {
      this.taskStaffData.stafftasksheet_set.forEach((item) => {
        if (item.id === response.staff_task_sheet) {
          item.tasks = ++item.tasks;
          item.hkstafftask_set = item.hkstafftask_set.map((task) => {
            if (task.staff_task_sheet !== response.staff_task_sheet) {
              task.staff_task_sheet = response.staff_task_sheet;
            }
            return task;
          });
          if (response.task_status == "hk_completed") {
            response = { ...response, fixed: true };
            if (status !== "isMove") {
              item.hkstafftask_set.unshift(response);
            }
          } else {
            response = { ...response, fixed: false };
            if (status !== "isMove") {
              item.hkstafftask_set.unshift(response);
            }
          }
          if (response.task_status === "hk_pending") {
            item.pending_tasks = ++item.pending_tasks;
          }
          if (response.task_status === "hk_in_progress") {
            item.in_progres_tasks = ++item.in_progres_tasks;
          }
          item.credit =
            parseFloat(item.credit) + parseFloat(response.room.hk_credit);
        }
        if (item.id === data.staff_task_sheet) {
          item.tasks = --item.tasks;
          if (data.task_status === "hk_pending") {
            item.pending_tasks = --item.pending_tasks;
          }
          if (data.task_status === "hk_in_progress") {
            item.in_progres_tasks = --item.in_progres_tasks;
          }
          if (status !== "isMove") {
            item.credit =
              parseFloat(item.credit) - parseFloat(data.room.hk_credit);
          } else {
            item.credit = parseFloat(item.credit) - parseFloat(data.credit);
          }
        }
      });
      Middleware.notification("Task updated successfully !!", "success");
      this.repeated = true;
      this.getTaskSheetDetails();
    },
    // Method is use for move task over one staff to other one
    moveTaskOverStaff(data) {
      if (this.selectStaffToMove !== "") {
        hkService
          .updateTaskSheet(data.id, {
            priority_order: 1,
            staff_task_sheet: this.selectStaffToMove.value,
          })
          .then((response) => {
            this.getResponse(data, response);
          })
          .catch((error) => {
            errorHandler(error);
          });
        this.rightClick = false;
        this.taskId = "";
        this.selectStaffToMove = "";
      }
    },
    // Method is use for move task over one staff to other
    endFunc() {
      this.isDragging = false;
      if (this.draggedElement.element.fixed) {
        Middleware.notification(
          "You can't move completed or in progress task !!",
          "info"
        );
      } else {
        if (
          this.relatedElement.element.staff_task_sheet ==
          this.draggedElement.element.staff_task_sheet
        ) {
          hkService
            .updateTaskSheet(this.draggedElement.element.id, {
              priority_order: this.draggedElement.futureIndex + 1,
            })
            .then((response) => {
              Middleware.notification(
                "Task updated successfully !!",
                "success"
              );
              this.repeated = true;
              this.getTaskSheetDetails();
            })
            .catch((error) => {
              errorHandler(error);
            });
        } else {
          hkService
            .updateTaskSheet(this.draggedElement.element.id, {
              priority_order: this.draggedElement.futureIndex + 1,
              staff_task_sheet: this.relatedElement.element.staff_task_sheet,
            })
            .then((response) => {
              const data = {
                staff_task_sheet: this.draggedElement.element.staff_task_sheet,
                task_status: this.draggedElement.element.task_status,
                credit: this.draggedElement.element.room.hk_credit,
              };
              this.getResponse(data, response, "isMove");
            })
            .catch((error) => {
              errorHandler(error);
            });
        }
      }
    },
    openCleanTaskConsole() {
      localStorage.setItem(
        "task",
        JSON.stringify({
          id: this.taskStaffData.id,
          date: this.taskStaffData.sheet_date,
        })
      );
      this.$router.push({ path: `/cleaning-task` });
    },
  },
};
</script>

<template>
  <div>
    <PageHeader
      :title="title"
      :isIcon="true"
      :classValue="'fa fas fa-tv fa-2x'"
      :action="openCleanTaskConsole"
      :hoverValue="'open clean task console'"
    />
    <b-card>
      <div class="col-md-12">
        <div class="row">
          <template v-if="isDataLoading">
            <div class="col-md-4 placeholder-glow">
              <div class="placeholder w-100 task-sheet-height"></div>
            </div>
            <div class="col-md-4 placeholder-glow">
              <div class="placeholder w-100 task-sheet-height"></div>
            </div>
            <div class="col-md-4 placeholder-glow">
              <div class="placeholder w-100 task-sheet-height"></div>
            </div>
          </template>
          <template v-else>
            <div
              class="col-md-4"
              v-for="(item, itemIndex) in taskStaffData.stafftasksheet_set"
              :key="itemIndex"
            >
              <template>
                <div class="mb-3">
                  <div class="table-responsive table-shadow">
                    <div class="bg-primary p-2">
                      <div
                        class="d-flex justify-content-between align-items-center"
                      >
                        <h5 class="mb-0 text-white">
                          #{{ item.staff_user.staff_id }}
                        </h5>

                        <div class="d-flex align-items-center">
                          <h5 class="mb-0 text-white me-2">
                            {{
                              item.staff_user.first_name +
                              " " +
                              item.staff_user.last_name
                            }}
                          </h5>
                          <img
                            v-if="item.staff_user.profile_picture !== ''"
                            class="rounded-circle header-picture-img"
                            :src="item.staff_user.profile_picture"
                            alt="Avatar"
                          />
                          <span
                            v-else
                            class="avatar-title bg-soft bg-dark font-20 rounded-circle header-picture-img"
                          >
                            {{
                              avatarGenerator(
                                item.staff_user.first_name +
                                  " " +
                                  item.staff_user.last_name
                              )
                            }}
                          </span>
                        </div>
                      </div>
                    </div>
                    <table class="table mb-0">
                      <thead>
                        <div class="bg-lightgray d-flex">
                          <div style="width: 11%">Room</div>
                          <div style="width: 24%">Status</div>
                          <div style="width: 12%">TT</div>
                          <div style="width: 25%" class="text-center">
                            Reservation
                          </div>
                          <div style="width: 15%" class="text-center">Room</div>
                          <div>Action</div>
                        </div>
                      </thead>
                      <template v-if="isDataLoading">
                        <tbody>
                          <tr v-for="(item, index) in 5" :key="index">
                            <td class="placeholder-glow">
                              <span
                                class="placeholder w-100 placeholder-lg"
                              ></span>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                      <template v-else>
                        <div>
                          <draggable
                            class="list-group"
                            tag="tbody"
                            v-model="item.hkstafftask_set"
                            v-bind="dragOptions"
                            :move="onMove"
                            @start="isDragging = true"
                            @end="endFunc"
                          >
                            <transition-group
                              type="transition"
                              :name="'flip-list'"
                            >
                              <div
                                class="list-group-item cursor-move"
                                v-for="data in item.hkstafftask_set"
                                :key="data.room.id"
                              >
                                <!-- contextmenu -->
                                <div class="d-flex w-100">
                                  <div
                                    v-if="rightClick && data.id == taskId"
                                    style="
                                      margin-top: -10px;
                                      z-index: 1;
                                      left: 28%;
                                    "
                                    class="position-absolute w-50"
                                  >
                                    <MultiSelect
                                      v-model="selectStaffToMove"
                                      :options="staffOptions"
                                      :show-labels="false"
                                      placeholder="Staff Name"
                                      track-by="value"
                                      label="text"
                                      name="status"
                                      @close="moveTaskOverStaff(data)"
                                    />
                                  </div>
                                  <div
                                    class="cursor-move text-start"
                                    style="width: 10%"
                                  >
                                    {{ data.room.room_number }}
                                  </div>
                                  <div
                                    style="
                                      margin-top: -10px;
                                      z-index: 1;
                                      left: 45px;
                                      width: 25%;
                                    "
                                    class="position-absolute"
                                    v-if="
                                      sheetId == data.room.id &&
                                      sheetId !== '' &&
                                      changeStatus === 'TaskStatus'
                                    "
                                  >
                                    <MultiSelect
                                      v-model="data.task_status"
                                      :options="data.statusOptions"
                                      :show-labels="false"
                                      placeholder="Task Status"
                                      track-by="type"
                                      label="name"
                                      name="taskStatus"
                                      @close="changeStatusFunc(data)"
                                      class="w-100"
                                    />
                                  </div>
                                  <div class="w-25">
                                    <div
                                      class="badge py-1 px-2 card-badge me-2"
                                      :class="
                                        data.task_status == 'hk_pending' ||
                                        data.task_status == 'hk_in_progress'
                                          ? 'badge-soft-warning'
                                          : data.task_status == 'hk_completed'
                                          ? 'badge-soft-success'
                                          : data.task_status ==
                                              'hk_discrepancy' ||
                                            data.task_status == 'hk_dnd'
                                          ? 'badge-soft-secondary'
                                          : data.task_status == 'in_reject'
                                          ? 'badge-soft-danger'
                                          : data.task_status == 'in_pending'
                                          ? 'badge-soft-primary'
                                          : data.task_status == 'in_done'
                                          ? 'badge-soft-info'
                                          : data.task_status ==
                                            'mark_delay_service'
                                          ? 'badge-soft-dark'
                                          : 'badge-soft-info'
                                      "
                                    >
                                      {{
                                        data.task_status == "hk_pending"
                                          ? "Pending"
                                          : data.task_status == "hk_completed"
                                          ? "Completed"
                                          : data.task_status == "hk_in_progress"
                                          ? "In Progress"
                                          : data.task_status == "hk_discrepancy"
                                          ? "Discrepancy"
                                          : data.task_status == "hk_dnd"
                                          ? "DND"
                                          : data.task_status == "in_reject"
                                          ? "Rejected"
                                          : data.task_status == "in_pending"
                                          ? "Insp Pending"
                                          : data.task_status == "in_done"
                                          ? "Insp Done"
                                          : data.task_status ==
                                            "mark_delay_service"
                                          ? "Paused"
                                          : ""
                                      }}
                                    </div>
                                  </div>
                                  <div
                                    style="
                                      margin-top: -10px;
                                      z-index: 1;
                                      left: 160px;
                                    "
                                    class="position-absolute"
                                    v-if="
                                      sheetId == data.room.id &&
                                      sheetId !== '' &&
                                      changeStatus === 'TTStatus'
                                    "
                                  >
                                    <MultiSelect
                                      v-model="data.status"
                                      :options="TTOptions"
                                      :show-labels="false"
                                      placeholder="TT Status"
                                      track-by="value"
                                      label="text"
                                      name="TTStatus"
                                      @close="changeStatusFunc(data)"
                                      class="w-100"
                                    />
                                  </div>
                                  <div style="width: 12%" class="me-1">
                                    {{
                                      data.task_type == "full" ? "Full" : "Half"
                                    }}
                                  </div>
                                  <div
                                    style="width: 25%"
                                    class="me-1 text-center"
                                    @click="
                                      () => {
                                        rightClick = false;
                                        taskId = '';
                                        changeStatus = '';
                                        sheetId = '';
                                      }
                                    "
                                  >
                                    {{
                                      data.booking !== null ? "Arrival" : "-"
                                    }}
                                  </div>
                                  <div
                                    style="width: 15%"
                                    class="text-center"
                                    @click="
                                      () => {
                                        rightClick = false;
                                        taskId = '';
                                        changeStatus = '';
                                        sheetId = '';
                                      }
                                    "
                                  >
                                    {{
                                      data.room.occupancy_status.toUpperCase()
                                    }}
                                  </div>
                                  <div style="width: 10%" class="text-center">
                                    <b-dropdown
                                      size="sm"
                                      variant="white"
                                      toggle-class="p-0"
                                      menu-class="dropdown-menu-end"
                                      right
                                    >
                                      <template #button-content>
                                        <i
                                          class="fas fa-ellipsis-v text-primary"
                                        ></i>
                                      </template>
                                      <b-dropdown-item
                                        v-if="!data.fixed"
                                        href="#"
                                        @click="func(data)"
                                      >
                                        Move Task
                                      </b-dropdown-item>
                                      <b-dropdown-item
                                        v-if="data.task_status !== 'in_reject'"
                                        href="#"
                                        @click="
                                          showDropDown(
                                            data.room.id,
                                            'TaskStatus'
                                          )
                                        "
                                      >
                                        Change Task status
                                      </b-dropdown-item>
                                      <b-dropdown-item
                                        v-if="!data.fixed"
                                        href="#"
                                        @click="
                                          showDropDown(data.room.id, 'TTStatus')
                                        "
                                      >
                                        Change TT status
                                      </b-dropdown-item>
                                    </b-dropdown>
                                  </div>
                                </div>
                              </div>
                            </transition-group>
                          </draggable>
                        </div>
                      </template>
                      <tfoot>
                        <div
                          class="bg-lightgray d-flex align-items-center justify-content-between"
                        >
                          <div>
                            <span>Morning Cleaning Sequence </span>
                          </div>
                          <div>
                            <span class="text-end">
                              <span
                                class="text-success"
                                v-b-popover.hover.left="'Clean Rooms'"
                                >{{ item.completed_task }}</span
                              >
                              |
                              <span
                                class="text-danger"
                                v-b-popover.hover.left="'In Progress Rooms'"
                                >{{ item.in_progress_task }}</span
                              >
                              |
                              <span
                                class="text-warning"
                                v-b-popover.hover.left="'Pending Rooms'"
                                >{{ item.pending_task }}</span
                              >
                            </span>
                          </div>
                        </div>
                        <div
                          class="d-flex align-items-center justify-content-between footer-color"
                        >
                          <div>Rooms : {{ item.total_task }}</div>
                          <div>Credit : {{ item.total_credit }}</div>
                        </div>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </template>
            </div>
          </template>
        </div>
      </div>
    </b-card>
    <b-modal
      id="reason-modal"
      centered
      :title="reasonTitle"
      hide-footer
      title-class="font-18"
      @hidden="resetModal"
      ref="reason-modal"
    >
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <b-form-group :label="reasonStatus" label-for="name-input">
          <p slot="label">
            {{ reasonStatus }} Reason <span class="text-danger">*</span>
          </p>
          <MultiSelect
            v-model="reason"
            :options="reasonOptions"
            :show-labels="false"
            placeholder="reason"
            track-by="value"
            label="text"
            :class="{
              'is-invalid': submitted && $v.reason.$error,
            }"
          />
          <div v-if="submitted" class="invalid-feedback">
            <span v-if="!$v.reason.required">Reason is required.</span>
          </div>
        </b-form-group>
        <div class="row">
          <div class="col-md-12">
            <button
              class="btn btn-primary me-2 float-end mt-2"
              @click="handleOk"
            >
              Update
            </button>
            <!-- <button class="btn btn-danger ms-2">Cancel</button> -->
          </div>
        </div>
      </form>
    </b-modal>
  </div>
</template>

<style scoped>
th,
td {
  text-align: left;
}

.total-number {
  color: #000000;
}

.round-circle {
  display: block;
  margin: auto;
  width: 18px;
  height: 18px;
  border-radius: 50%;
}

.footer-color {
  background-color: #d7d7d7;
}

.header-picture-img {
  height: 30px;
  width: 30px;
  object-fit: cover;
}

.flip-list-move {
  transition: transform 0.5s;
}

.no-move {
  transition: transform 0s;
}

.list-group {
  min-height: 20px;
}

.w-20 {
  width: 20%;
}

.list-group-item {
  border: 0px;
  padding: 12px 0px;
  border-bottom: 1px solid #dee2e6;
}

.table-shadow {
  box-shadow: 0px 0 25px 0 rgb(0 0 0 / 5%);
}

.task-sheet-height {
  height: 450px;
}
</style>
